import { Box, Flex } from '@npco/zeller-design-system'

export const ModalHeading = ({ title }: { title: string }) => (
  <Flex width="100%" justifyContent="center">
    <Box maxWidth="310px">{title}</Box>
  </Flex>
)
